function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import VueRouter from 'vue-router';

// load app views and components for use in route
var Error403 = function Error403() {
  return import('@/views/403.vue');
};
var Error404 = function Error404() {
  return import('@/views/404.vue');
};
var MainSearch = function MainSearch() {
  return import('@/views/MainSearch.vue');
};
// import ContLogin from '@/views/ContLogin.vue'
var ContLoadBulk = function ContLoadBulk() {
  return import('@/views/ContLoadBulk.vue');
};
var ContAddTablesWithCron = function ContAddTablesWithCron() {
  return import('@/views/ContAddTablesWithCron.vue');
};
var SyncTableFlagInca = function SyncTableFlagInca() {
  return import('@/views/SyncTableFlagInca.vue');
};
var ContDatasourcesAssignment = function ContDatasourcesAssignment() {
  return import('@/views/ContDatasourcesAssignment');
};
var ContDashboardAssignment = function ContDashboardAssignment() {
  return import('@/views/ContDashboardAssignment');
};
var ContReportAssignment = function ContReportAssignment() {
  return import('@/modules/tasks/powerbi/ContReportAssignment');
};
var ContDatasetAssignment = function ContDatasetAssignment() {
  return import('@/modules/tasks/powerbi/ContDatasetAssignment');
};
var DSContReportAssignment = function DSContReportAssignment() {
  return import('@/modules/tasks/datastudio/DSContReportAssignment');
};
var DSContDatasourceAssignment = function DSContDatasourceAssignment() {
  return import('@/modules/tasks/datastudio/DSContDatasourceAssignment');
};
var DatasourcesAssignment = function DatasourcesAssignment() {
  return import('@/modules/tasks/datastudio/DatasourcesAssignment');
};
var VisualizationUserAccessGDS = function VisualizationUserAccessGDS() {
  return import('@/modules/tasks/datastudio/VisualizationUserAccessGDS');
};
var ContMonitoring = function ContMonitoring() {
  return import('@/views/ContMonitoring.vue');
};
var ContDataDashboard = function ContDataDashboard() {
  return import('@/views/ContDataDashboard.vue');
};
var ContDlpDashboard = function ContDlpDashboard() {
  return import('@/views/ContDlpDashboard.vue');
};
var ContLineageIframes = function ContLineageIframes() {
  return import('@/views/ContLineageIframes.vue');
};
//import ContAssignments from '@/views/refactoring/ContAssignments.vue'
//import TableAssignmentsPage from '@/apps/data-platform/modules/my_tasks/TableAssignmentsPage.vue'
var TableAssignmentsPage = function TableAssignmentsPage() {
  return import('@/apps/data-platform/modules/my_tasks/TableAssignmentsPage.vue');
};
// import ContMyObjects from '@/views/refactoring/ContMyObjects.vue'
var MyObjectsPage = function MyObjectsPage() {
  return import('@/apps/data-platform/modules/my_objects/MyObjectsPage.vue');
};
//import ContMassiveDownload from '@/views/refactoring/ContMassiveDownload.vue'
var DownloadMetadataPage = function DownloadMetadataPage() {
  return import('@/apps/data-platform/modules/my_tasks/DownloadMetadataPage.vue');
};
//import ContDpArea from '@/views/ContDpArea.vue'
var AreaPage = function AreaPage() {
  return import('@/apps/data-platform/modules/user_profiles/AreaPage.vue');
};
//import ContDpProfileAssignment from '@/views/ContDpProfileAssignment.vue'
var ProfileAssignmentPage = function ProfileAssignmentPage() {
  return import('@/apps/data-platform/modules/user_profiles/ProfileAssignmentPage.vue');
};
//import ContDpUserprofile from '@/views/ContDpUserprofile.vue'
var ProfilePage = function ProfilePage() {
  return import('@/apps/data-platform/modules/user_profiles/ProfilePage.vue');
};
//import ContDpUserprofileTable from '@/views/ContDpUserprofileTable.vue'
var TableDetailPage = function TableDetailPage() {
  return import('@/apps/data-platform/modules/user_profiles/TableDetailPage.vue');
};

// import ContAssignments from '@/views/ContAssignments.vue'
// import ContMyTables from '@/views/ContMyTables.vue'
var ContMyActivity = function ContMyActivity() {
  return import('@/views/ContMyActivity.vue');
};

// import ContTablesAccessRequested from '@/views/ContTablesAccessRequested.vue'
// import ContTablesChangeMetadataRequested from '@/views/ContTablesChangeMetadataRequested.vue'
var ChangeMetadataRequestPage = function ChangeMetadataRequestPage() {
  return import('@/apps/data-platform/modules/my_pendings/ChangeMetadataRequestPage.vue');
};
// import ContPendingAssignmentsMe from '@/views/ContPendingAssignmentsMe.vue'
var AccessRequestPage = function AccessRequestPage() {
  return import('@/apps/data-platform/modules/my_pendings/AccessRequestPage.vue');
};
var OwnershipPage = function OwnershipPage() {
  return import('@/apps/data-platform/modules/my_pendings/OwnershipPage.vue');
};
// import ContObjectSearch from '@/views/ContObjectSearch.vue'
var PrincipalSearchPage = function PrincipalSearchPage() {
  return import('@/apps/data-platform/modules/principal_search/PrincipalSearchPage.vue');
};
var DataStudioDashboard = function DataStudioDashboard() {
  return import('@/views/DataStudioDashboard.vue');
};
//import InitialSetupsPage from '@/apps/data-platform/modules/initial_setups/InitialSetupsPage.vue'
var InitialSetupPage = function InitialSetupPage() {
  return import('@/apps/data-platform/modules/initial_setup/InitialSetupPage.vue');
};
//import ContMassiveUpdate from '@/views/ContMassiveUpdate.vue'
var MassiveUpdatePage = function MassiveUpdatePage() {
  return import('@/apps/data-platform/modules/my_tasks/MassiveUpdatePage2');
};
// import ContMassiveAccessRequest from '@/views/ContMassiveAccessRequest.vue'
var MassiveSetupRequestPage = function MassiveSetupRequestPage() {
  return import('@/apps/data-platform/modules/my_pendings/MassiveSetupRequestPage.vue');
};
// import ContMassiveDownload from '@/views/ContMassiveDownload.vue'
var DisplayImage = function DisplayImage() {
  return import('@/views/DisplayImage.vue');
};
// import DataGovernanceRoles from '@/views/DataGovernanceRoles.vue'
var RolesPage = function RolesPage() {
  return import('@/apps/data-platform/modules/roles/RolesPage.vue');
};
var Settings = function Settings() {
  return import('@/apps/configuration/Settings.vue');
};
//import AccessManagementReport from '@/views/AccessManagementReport.vue'
var AccessManagementReportPage = function AccessManagementReportPage() {
  return import('@/apps/data-platform/modules/monitoring/AccessManagementReportPage');
};
// import BusinessGlossary from '@/views/BusinessGlossary.vue'
var BusinessGlossaryPage = function BusinessGlossaryPage() {
  return import('@/apps/data-platform/modules/business_terms/BusinessGlossaryPage.vue');
};
var BusinessGlossaryLoadBulk = function BusinessGlossaryLoadBulk() {
  return import('@/apps/data-platform/modules/business_terms/BusinessGlossaryLoadBulk.vue');
};
var BusinessDomain = function BusinessDomain() {
  return import('@/views/BusinessDomain.vue');
};
// import BusinessTerm from '@/views/BusinessTerm.vue'
var BusinessTermDetailPage = function BusinessTermDetailPage() {
  return import('@/apps/data-platform/modules/business_terms/BusinessTermDetailPage.vue');
};
var PxRolesGrid = function PxRolesGrid() {
  return import('@/components/refactoring/PxRolesGrid.vue');
};
var VisualizationUserAccess = function VisualizationUserAccess() {
  return import('@/views/tableau/VisualizationUserAccess.vue');
};
var VisualizationUserAccessBi = function VisualizationUserAccessBi() {
  return import('@/modules/tasks/powerbi/VisualizationUserAccessBi.vue');
};
var ConsumptionReportKPI = function ConsumptionReportKPI() {
  return import('@/views/ConsumptionReportKPI.vue');
};
var ProfilingValidationType = function ProfilingValidationType() {
  return import('@/views/profiling/ValidationType.vue');
};
var ProfilingHistoryPage = function ProfilingHistoryPage() {
  return import('@/apps/data-platform/modules/data_quality/ProfilingHistoryPage');
};
var ProfilingScoreParams = function ProfilingScoreParams() {
  return import('@/views/profiling/ScoreParams');
};
var DataStrategy = function DataStrategy() {
  return import('@/modules/data_strategy/DataStrategy');
};
var AssessmentReport = function AssessmentReport() {
  return import('@/apps/data-platform/modules/data_estrategy/AssessmentReport');
};
var AdminAssessmentReport = function AdminAssessmentReport() {
  return import('@/apps/data-platform/modules/data_estrategy/AdminAssessmentReport');
};
var DopsDataLineage = function DopsDataLineage() {
  return import('@/modules/dops/DopsDataLineage');
};
var GDSReportViewer = function GDSReportViewer() {
  return import('@/modules/my-objects/GDSReportViewer');
};
var ViewVideo = function ViewVideo() {
  return import('@/apps/data-platform/modules/help_center/components/view_video.vue');
};
var ListElements = function ListElements() {
  return import('@/apps/data-platform/modules/help_center/components/list_elements.vue');
};
//import HomePage from '@/apps/data-platform/modules/home_page/home_page.vue'
var HomePage = function HomePage() {
  return import('@/apps/data-platform/modules/home_page/home_page.vue');
};
var INCAMetrics = function INCAMetrics() {
  return import('@/apps/data-platform/modules/audit_monitoring/INCAMetrics.vue');
};
var ObjectLink = function ObjectLink() {
  return import('@/components/ObjectLink.vue');
};

// Load constants and functions utils
import { envConfig, MENU_DICT, ROLES_LIST } from '@/js/constants';
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import AudiencesRoutes from './apps/audiences/routes';
import AttributesRoutes from './apps/attributes/routes';
import CustomerInsightsRoutes from './apps/customer-insigths/routes';
import DataOpsRoutes from './apps/dataops/routes';
import AnalyticServicesRoutes from './apps/analytic-services/routes';
import UseMetricsRoutes from './apps/use-metrics/routes';
import ChatbotsRoutes from './apps/chatbots/routes';
import AssetGovernanceRoutes from './apps/asset-governance/routes';
import PerformanceEvaluationRoutes from './apps/performance-evaluation/routes';
var ConfigPage = function ConfigPage() {
  return import('@/apps/data-platform/modules/data_quality_dataplex/ConfigPage.vue');
};
var RulesPage = function RulesPage() {
  return import('@/apps/data-platform/modules/data_quality_dataplex/RulesPage.vue');
};
var ProfilingPage = function ProfilingPage() {
  return import('@/apps/data-platform/modules/data_quality_dataplex/ProfilingPage.vue');
};
var DataQualityPage = function DataQualityPage() {
  return import('@/apps/data-platform/modules/data_quality_dataplex/DataQualityPage.vue');
};
var DataQualityCreatePage = function DataQualityCreatePage() {
  return import('@/apps/data-platform/modules/data_quality_dataplex/DataQualityCreatePage.vue');
};
var ProfilingCreatePage = function ProfilingCreatePage() {
  return import('@/apps/data-platform/modules/data_quality_dataplex/ProfilingCreatePage.vue');
};
var ControlDashboardPage = function ControlDashboardPage() {
  return import('@/apps/data-platform/modules/data_quality_dataplex/ControlDashboardPage.vue');
};
var ExecutiveDashboardPage = function ExecutiveDashboardPage() {
  return import('@/apps/data-platform/modules/data_quality_dataplex/ExecutiveDashboardPage.vue');
};
var DashboardMaintenancePage = function DashboardMaintenancePage() {
  return import('@/apps/data-platform/modules/data_quality_dataplex/DashboardMaintenancePage.vue');
};
var LogAccess = function LogAccess() {
  return import('@/apps/configuration/LogAccess');
};
var AdminLogPowerBI = function AdminLogPowerBI() {
  return import('@/apps/data-platform/modules/powerbi_log_report/AdminLogPowerBI.vue');
};
var LogPowerBI = function LogPowerBI() {
  return import('@/apps/data-platform/modules/powerbi_log_report/LogPowerBI.vue');
};
var MonitoringMaintenance = function MonitoringMaintenance() {
  return import('@/apps/data-platform/modules/monitoring_billing/MonitoringMaintenance.vue');
};
var MonitoringReports = function MonitoringReports() {
  return import('@/apps/data-platform/modules/monitoring_billing/MonitoringReports.vue');
};
var MonitoringReportsView = function MonitoringReportsView() {
  return import('@/apps/data-platform/modules/monitoring_billing/MonitoringReportsView.vue');
};
var ReportManagementPage = function ReportManagementPage() {
  return import('@/apps/data-platform/modules/report_management/reportManagementPage/ReportManagementPage.vue');
};
var ViewReportPage = function ViewReportPage() {
  return import('@/apps/data-platform/modules/report_management/viewReportPage/ViewReportPage.vue');
};
var MigrationsPage = function MigrationsPage() {
  return import('@/apps/data-platform/modules/migrations/MigrationsPage.vue');
};
var _getPermissiosInMenuDict = function getPermissiosInMenuDict(routeName) {
  var menuDict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MENU_DICT;
  /* used to obtain permissions in the MENU_DICT
      : param routeName : give the names of the routes
      : param menuDict : get data like roles, names and permissions of each role
     */
  for (var i = 0; i < menuDict.length; i++) {
    var menuItem = menuDict[i];
    var menuName = menuItem.href && menuItem.href.name;
    var subitems = menuItem.subItems;

    // get level 1
    if (menuName === routeName) {
      return menuItem.roles;
    }
    // get second level next
    if (subitems) {
      var roles = _getPermissiosInMenuDict(routeName, subitems);
      if (roles && roles.length > 0) {
        return roles;
      }
    }
  }
  return [];
};

// declare rotes and assign role permissions
var router = new VueRouter({
  routes: [].concat(_toConsumableArray(AudiencesRoutes), _toConsumableArray(AttributesRoutes), _toConsumableArray(CustomerInsightsRoutes), _toConsumableArray(DataOpsRoutes), _toConsumableArray(AnalyticServicesRoutes), _toConsumableArray(UseMetricsRoutes), _toConsumableArray(ChatbotsRoutes), _toConsumableArray(AssetGovernanceRoutes), _toConsumableArray(PerformanceEvaluationRoutes), [{
    path: '/',
    name: 'root',
    redirect: {
      name: 'HomePage'
    }
  }, {
    path: '/callback',
    component: function component() {
      return import(/* webpackChunkName: "auth-verify-email" */'@/pages/auth/RedirectHandler.vue');
    },
    meta: {
      layout: 'auth'
    }
  }, {
    path: '/Home',
    name: 'HomePage',
    components: {
      default: HomePage,
      search: HomePage
    }
  }, {
    path: '/ContLogin',
    name: 'ContLogin',
    /* components: { login: ContLogin },*/
    component: function component() {
      return import(/* webpackChunkName: "auth-verify-email" */'@/pages/auth/SigninPage.vue');
    },
    meta: {
      layout: 'auth'
    }
  }, {
    path: '/auth/microsoft/login',
    name: 'AuthPage',
    /* components: { login: ContLogin },*/
    component: function component() {
      return import(/* webpackChunkName: "auth-verify-email" */'@/pages/auth/AuthPage.vue');
    },
    meta: {
      layout: 'auth'
    }
  }, {
    path: '/tables/MyTables/:tab?',
    name: 'MyTables',
    components: {
      default: MyObjectsPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('MyTables')
    }
  }, {
    path: '/tables/ContObjectSearch/:q/:domain?',
    name: 'ContObjectSearch',
    components: {
      default: PrincipalSearchPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContObjectSearch')
    }
  }, {
    path: '/tables/ContLineageIframes/',
    name: 'ContLineageIframes',
    components: {
      default: ContLineageIframes,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContLineageIframes')
    }
  }, {
    path: '/Requests/ContAssignments',
    name: 'ContAssignments',
    components: {
      default: TableAssignmentsPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContAssignments')
    }
  }, {
    path: '/Requests/ContPendingAssignmentsMe',
    name: 'ContPendingAssignmentsMe',
    components: {
      default: OwnershipPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContPendingAssignmentsMe')
    }
  }, {
    path: '/Requests/ContTablesAccessRequested',
    name: 'ContTablesAccessRequested',
    components: {
      default: AccessRequestPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContTablesAccessRequested')
    }
  }, {
    path: '/Requests/MetadataChangeRequested',
    name: 'ContTablesChangeMetadataRequested',
    components: {
      default: ChangeMetadataRequestPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContTablesChangeMetadataRequested')
    }
  }, {
    path: '/Requests/ContMyActivity',
    name: 'ContMyActivity',
    components: {
      default: ContMyActivity,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContMyActivity')
    }
  }, {
    path: '/Requests/ContMyActivity',
    name: 'ContMyActivity',
    components: {
      default: ContMyActivity,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContMyActivity')
    }
  }, {
    path: '/Monitoring/ContMonitoring',
    name: 'ContMonitoring',
    components: {
      default: ContMonitoring,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContMonitoring')
    }
  },
  // TODO: delete  ContDataDashboard, ContDlpDashboard
  {
    path: '/Monitoring/ContDataDashboard',
    name: 'ContDataDashboard',
    components: {
      default: ContDataDashboard,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContDataDashboard')
    }
  }, {
    path: '/Monitoring/ContDlpDashboard',
    name: 'ContDlpDashboard',
    components: {
      default: ContDlpDashboard,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContDlpDashboard')
    }
  }, {
    path: '/Metadata/ContLoadBulk',
    name: 'ContLoadBulk',
    components: {
      default: ContLoadBulk,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContLoadBulk')
    }
  }, {
    path: '/Metadata/ContAddTablesWithCron',
    name: 'ContAddTablesWithCron',
    components: {
      default: ContAddTablesWithCron,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContAddTablesWithCron')
    }
  }, {
    path: '/Tables/SyncTableFlagInca',
    name: 'SyncTableFlagInca',
    components: {
      default: SyncTableFlagInca,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('SyncTableFlagInca')
    }
  }, {
    path: '/Metadata/ContDatasourcesAssignment',
    name: 'ContDatasourcesAssignment',
    components: {
      default: ContDatasourcesAssignment,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContDatasourcesAssignment')
    }
  }, {
    path: '/Metadata/ContDashboardAssignment',
    name: 'ContDashboardAssignment',
    components: {
      default: ContDashboardAssignment,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContDashboardAssignment')
    }
  }, {
    path: '/powerbi/ContDatasetAssignment',
    name: 'ContDatasetAssignment',
    components: {
      default: ContDatasetAssignment,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContDatasetAssignment')
    }
  }, {
    path: '/powerbi/ContReportAssignment',
    name: 'ContReportAssignment',
    components: {
      default: ContReportAssignment,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContReportAssignment')
    }
  }, {
    path: '/datastudio/DSContReportAssignment',
    name: 'DSContReportAssignment',
    components: {
      default: DSContReportAssignment,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DSContReportAssignment')
    }
  }, {
    path: '/datastudio/DatasourcesAssignment',
    name: 'DatasourcesAssignment',
    components: {
      default: DatasourcesAssignment,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DatasourcesAssignment')
    }
  }, {
    path: '/datastudio/DSContDatasourceAssignment',
    name: 'DSContDatasourceAssignment',
    components: {
      default: DSContDatasourceAssignment,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DSContDatasourceAssignment')
    }
  }, {
    path: '/datastudio/VisualizationUserAccessGDS',
    name: 'VisualizationUserAccessGDS',
    components: {
      default: VisualizationUserAccessGDS,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('VisualizationUserAccessGDS')
    }
  }, {
    path: '/datastudio/GDSReportViewer/:id',
    name: 'GDSReportViewer',
    components: {
      default: GDSReportViewer,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('GDSReportViewer')
    }
  }, {
    path: '/video/:video_id',
    name: 'ViewVideo',
    components: {
      default: ViewVideo,
      search: ViewVideo
    }
  }, {
    path: '/help_center/elements/:element_path/:module_path?',
    name: 'ListElements',
    components: {
      default: ListElements,
      search: ListElements
    }
  }, {
    path: '/ObjectLink/:object_type/:object_id',
    name: 'ObjectLink',
    components: {
      default: ObjectLink,
      search: ObjectLink
    }
  }, {
    path: '/Metadata/DisplayImage',
    name: 'DisplayImage',
    components: {
      default: DisplayImage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DisplayImage')
    }
  }, {
    path: '/DataQuality/ExecutiveDashboard',
    name: 'ExecutiveDashboard',
    components: {
      default: DataStudioDashboard
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ExecutiveDashboard'),
      type: 'ExecutiveDashboard',
      name: 'Executive Dashboard'
    }
  }, {
    path: '/DataQuality/OperationalDashboard',
    name: 'OperationalDashboard',
    components: {
      default: DataStudioDashboard
    },
    meta: {
      authentified: _getPermissiosInMenuDict('OperationalDashboard'),
      type: 'OperationalDashboard',
      name: 'Operational Dashboard'
    }
  }, {
    path: '/DataQuality/ProfilingDashboard',
    name: 'ProfilingDashboard',
    components: {
      default: DataStudioDashboard,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ProfilingDashboard'),
      type: 'ProfilingDashboard',
      name: 'Data Profiling Dashboard'
    }
  }, {
    path: '/ContInitialSetup',
    name: 'ContInitialSetup',
    components: {
      default: InitialSetupPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContInitialSetup')
    }
  }, {
    path: '/ContMassiveUpdate',
    name: 'ContMassiveUpdate',
    components: {
      default: MassiveUpdatePage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContMassiveUpdate')
    }
  }, {
    path: '/ContMassiveDownload',
    name: 'ContMassiveDownload',
    components: {
      default: DownloadMetadataPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContMassiveDownload')
    }
  }, {
    path: '/ContDpArea',
    name: 'ContDpArea',
    components: {
      default: AreaPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContDpArea')
    }
  }, {
    path: '/ContDpProfileAssignment',
    name: 'ContDpProfileAssignment',
    components: {
      default: ProfileAssignmentPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContDpProfileAssignment')
    }
  }, {
    path: '/ContDpUserprofile',
    name: 'ContDpUserprofile',
    components: {
      default: ProfilePage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContDpUserprofile')
    }
  }, {
    path: '/ContDpUserprofileTable',
    name: 'ContDpUserprofileTable',
    components: {
      default: TableDetailPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContDpUserprofileTable')
    }
  }, {
    path: '/ContMassiveAccessRequest',
    name: 'ContMassiveAccessRequest',
    components: {
      default: MassiveSetupRequestPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ContMassiveAccessRequest')
    }
  }, {
    path: '/DataGovernanceRoles',
    name: 'DataGovernanceRoles',
    components: {
      default: RolesPage,
      search: MainSearch
    },
    meta: {
      authentified: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ATTRIBUTE_SUPERVISOR, ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.SERVICE_MANAGER, ROLES_LIST.INSIGHTS_SERVICE_MANAGER, 'support_developer']
    }
  }, {
    path: '/Settings',
    name: 'Settings',
    components: {
      default: Settings
    },
    meta: {
      authentified: ['support_developer']
    }
  },
  /*{
    path: '/INCAMetrics', name: 'INCAMetrics',
    components: { default: INCAMetrics },
    meta: { authentified: getPermissiosInMenuDict('INCAMetrics') }
  },*/
  {
    path: '/AccessManagementReport',
    name: 'AccessManagementReport',
    components: {
      default: AccessManagementReportPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('AccessManagementReport')
    }
  }, {
    path: '/LogAccess',
    name: 'LogAccess',
    components: {
      default: LogAccess
    },
    meta: {
      authentified: [ROLES_LIST.ORG_DATA_STEWARD]
    }
  }, {
    path: '/Migrations',
    name: 'Migrations',
    components: {
      default: MigrationsPage,
      search: MainSearch
    },
    meta: {
      authentified: [ROLES_LIST.ORG_DATA_STEWARD],
      corporate: true
    }
  }, {
    path: '/TablesWithoutMetadataReport',
    name: 'TablesWithoutMetadataReport',
    component: function component() {
      return import('@/apps/data-platform/modules/audit_monitoring/TablesWithoutMetadataReportPage.vue');
    },
    meta: {
      authentified: _getPermissiosInMenuDict('TablesWithoutMetadataReport')
    }
  }, {
    path: '/BusinessGlossary',
    name: 'BusinessGlossary',
    components: {
      default: BusinessGlossaryPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('BusinessGlossary')
    }
  }, {
    path: '/BusinessGlossaryLoadBulk',
    name: 'BusinessGlossaryLoadBulk',
    components: {
      default: BusinessGlossaryLoadBulk,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('BusinessGlossaryLoadBulk')
    }
  }, {
    path: '/BusinessDomain',
    name: 'BusinessDomain',
    components: {
      default: BusinessDomain,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('BusinessDomain')
    }
  }, {
    path: '/BusinessTerm/:domain/:id',
    name: 'BusinessTerm',
    component: BusinessTermDetailPage,
    meta: {
      authentified: _getPermissiosInMenuDict('BusinessTerm')
    }
  }, {
    path: '/PxRolesGrid/:id',
    name: 'PxRolesGrid',
    components: {
      default: PxRolesGrid,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('PxRolesGrid')
    }
  }, {
    path: '/VisualizationUserAccess',
    name: 'VisualizationUserAccess',
    components: {
      default: VisualizationUserAccess,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('VisualizationUserAccess')
    }
  }, {
    path: '/powerbi/VisualizationUserAccess',
    name: 'VisualizationUserAccessBi',
    components: {
      default: VisualizationUserAccessBi,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('VisualizationUserAccessBi')
    }
  }, {
    path: '/ConsumptionReportKPI',
    name: 'ConsumptionReportKPI',
    components: {
      default: ConsumptionReportKPI,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ConsumptionReportKPI')
    }
  }, {
    path: '/ProfilingValidationType',
    name: 'ProfilingValidationType',
    components: {
      default: ProfilingValidationType,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ProfilingValidationType')
    }
  }, {
    path: '/ProfilingHistory',
    name: 'ProfilingHistoryPage',
    components: {
      default: ProfilingHistoryPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ProfilingHistoryPage')
    }
  }, {
    path: '/ProfilingScoreParams',
    name: 'ProfilingScoreParams',
    components: {
      default: ProfilingScoreParams,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('ProfilingHistoryPage')
    }
  }, {
    path: '/DataQuality/Config',
    name: 'DataQualityConfigPage',
    components: {
      default: ConfigPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataQualityConfigPage'),
      check_flag: 'data-platform/has_dataplex_active',
      corporate: true
    }
  }, {
    path: '/DataQuality/Rules',
    name: 'DataQualityRulesPage',
    components: {
      default: RulesPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataQualityRulesPage'),
      check_flag: 'data-platform/has_dataplex_active'
    }
  }, {
    path: '/DataQuality/Profiling',
    name: 'DataQualityProfilingPage',
    components: {
      default: ProfilingPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataQualityProfilingPage'),
      check_flag: 'data-platform/has_dataplex_active'
    }
  }, {
    path: '/DataQuality/ProfilingSummary',
    name: 'DataProfilingSummaryPage',
    component: function component() {
      return import('@/apps/data-platform/modules/data_quality_dataplex/ProfilingSummaryPage.vue');
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataQualityProfilingPage'),
      check_flag: 'data-platform/has_dataplex_active'
    }
  }, {
    path: '/DataQuality/Profiling/Create',
    name: 'DataProfilingCreatePage',
    components: {
      default: ProfilingCreatePage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataQualityProfilingPage'),
      mode: 'create',
      check_flag: 'data-platform/has_dataplex_active'
    }
  }, {
    path: '/DataQuality/Profiling/Edit/:id',
    name: 'DataProfilingEditPage',
    components: {
      default: ProfilingCreatePage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataQualityProfilingPage'),
      mode: 'edit',
      check_flag: 'data-platform/has_dataplex_active'
    }
  }, {
    path: '/DataQuality/Profiling/View/:id',
    name: 'DataProfilingViewPage',
    components: {
      default: ProfilingCreatePage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataQualityProfilingPage'),
      mode: 'view',
      check_flag: 'data-platform/has_dataplex_active'
    }
  }, {
    path: '/DataQuality/Quality',
    name: 'DataQualityPage',
    components: {
      default: DataQualityPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataQualityPage'),
      check_flag: 'data-platform/has_dataplex_active'
    }
  }, {
    path: '/DataQuality/Quality/Create',
    name: 'DataQualityCreatePage',
    components: {
      default: DataQualityCreatePage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataQualityPage'),
      mode: 'create',
      check_flag: 'data-platform/has_dataplex_active'
    }
  }, {
    path: '/DataQuality/Quality/Edit/:id',
    name: 'DataQualityEditPage',
    components: {
      default: DataQualityCreatePage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataQualityPage'),
      mode: 'edit',
      check_flag: 'data-platform/has_dataplex_active'
    }
  }, {
    path: '/DataQuality/Quality/View/:id',
    name: 'DataQualityViewPage',
    components: {
      default: DataQualityCreatePage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataQualityPage'),
      mode: 'view',
      check_flag: 'data-platform/has_dataplex_active'
    }
  }, {
    path: '/DataQuality/ControlDashboardPage',
    name: 'DataQualityControlDashboardPage',
    components: {
      default: ControlDashboardPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataQualityPage'),
      mode: 'view',
      check_flag: 'data-platform/has_dataplex_active'
    }
  }, {
    path: '/DataQuality/ExecutiveDashboardPage',
    name: 'DataQualityExecutiveDashboardPage',
    components: {
      default: ExecutiveDashboardPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataQualityPage'),
      mode: 'view',
      check_flag: 'data-platform/has_dataplex_active'
    }
  }, {
    path: '/DataQuality/DashboardMaintenancePage',
    name: 'DataQualityDashboardMaintenancePage',
    components: {
      default: DashboardMaintenancePage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataQualityPage'),
      mode: 'view',
      check_flag: 'data-platform/has_dataplex_active'
    }
  }, {
    path: '/DataStrategy',
    name: 'DataStrategy',
    components: {
      default: DataStrategy,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DataStrategy'),
      corporate: true
    }
  }, {
    path: '/AssessmentReport',
    name: 'AssessmentReport',
    components: {
      default: AssessmentReport,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('AssessmentReport')
    }
  }, {
    path: '/AdminAssessmentReport',
    name: 'AdminAssessmentReport',
    components: {
      default: AdminAssessmentReport,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('AdminAssessmentReport'),
      corporate: true
    }
  }, {
    path: '/DopsDataLineage',
    name: 'DopsDataLineage',
    components: {
      default: DopsDataLineage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('DopsDataLineage')
    }
  }, {
    path: '/AdminLogPowerBI',
    name: 'AdminLogPowerBI',
    components: {
      default: AdminLogPowerBI,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('AdminLogPowerBI'),
      corporate: true
    }
  }, {
    path: '/LogPowerBI',
    name: 'LogPowerBI',
    components: {
      default: LogPowerBI,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('LogPowerBI')
    }
  }, {
    path: '/MonitoringMaintenance',
    name: 'MonitoringMaintenance',
    components: {
      default: MonitoringMaintenance,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('MonitoringMaintenance')
    }
  }, {
    path: '/MonitoringReports',
    name: 'MonitoringReports',
    components: {
      default: MonitoringReports,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('MonitoringReports')
    }
  }, {
    path: '/MonitoringReportsView',
    name: 'MonitoringReportsView',
    components: {
      default: MonitoringReportsView,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('MonitoringReportsView')
    }
  }, {
    path: '/report-management',
    name: 'report_management',
    components: {
      default: ReportManagementPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('MonitoringReportsView')
    }
  }, {
    path: '/report-view',
    name: 'report_management_view',
    components: {
      default: ViewReportPage,
      search: MainSearch
    },
    meta: {
      authentified: _getPermissiosInMenuDict('MonitoringReportsView')
    }
  }, {
    path: '/userSettings/profile/:email',
    name: 'profile',
    component: function component() {
      return import('@/apps/data-platform/modules/profile/MyProfilePage.vue');
    },
    meta: {
      mode: 'view'
    }
  }, {
    path: '/userSettings/MyNotifications',
    name: 'MyNotifications',
    components: {
      default: function _default() {
        return import('@/apps/data-platform/modules/notifications/MyNotificationsPage.vue');
      },
      search: MainSearch
    }
  }, {
    path: '/help_center/MainPage',
    name: 'help_main',
    component: function component() {
      return import('@/apps/data-platform/modules/help_center/HelpMainPage.vue');
    }
  }, {
    path: '/help_center/FAQPage',
    name: 'faq_page',
    component: function component() {
      return import('@/apps/data-platform/modules/help_center/FAQPage.vue');
    }
  }, {
    path: '/help_center/VideosPage',
    name: 'videos_page',
    component: function component() {
      return import('@/apps/data-platform/modules/help_center/VideosPage.vue');
    }
  }, {
    path: '/help_center/SugerenciasPage',
    name: 'sugerencias_page',
    component: function component() {
      return import('@/apps/data-platform/modules/help_center/SugerenciasPage.vue');
    }
  }, {
    path: '/help_center/ADMINPage',
    name: 'admin_page',
    component: function component() {
      return import('@/apps/data-platform/modules/help_center/ADMINPage.vue');
    },
    meta: {
      authentified: [ROLES_LIST.ADMIN, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD, ROLES_LIST.COMMUNITY_MANAGER],
      corporate: true
    } //getPermissiosInMenuDict('admin_page') }
  }, {
    path: '/AITools/GenerativeImage',
    name: 'GenerativeImage',
    component: function component() {
      return import('@/apps/data-platform/pages/GenerativeImage.vue');
    },
    meta: {
      authentified: [ROLES_LIST.ADMIN, ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.AUDIENCE_USER]
    }
  }, {
    path: '/DomainMaintenance',
    name: 'DomainMaintenance',
    component: function component() {
      return import('@/apps/configuration/DomainMaintenance.vue');
    },
    meta: {
      authentified: [ROLES_LIST.ORG_DATA_STEWARD, 'support_developer'],
      corporate: true
    }
  }, {
    path: '/WhitelistMaintenance',
    name: 'WhitelistMaintenance',
    component: function component() {
      return import('@/apps/configuration/WhitelistMaintenance.vue');
    },
    meta: {
      authentified: [ROLES_LIST.ORG_DATA_STEWARD, 'support_developer'],
      corporate: true
    }
  },
  /*{
    path: '/UserModuleAccess',
    name: 'UserModuleAccess',
    component: () => import('@/apps/data-platform/modules/audit_monitoring/UserModuleAccessReportPage.vue'),
    meta: { authentified: getPermissiosInMenuDict('UserModuleAccess'), corporate: true }
  },*/
  {
    path: '/403',
    name: '403',
    component: Error403
  }, {
    path: '*',
    name: 'not-found',
    component: Error404
  }])
});

/*
  @param  to   {String} where url goes to
  @param  from {String} where url comes from
  @param  next {function} for execute or change where url goes to
  @return {function} "next" return self function
*/
var _routerBeforeEach = function routerBeforeEach(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var next = arguments.length > 2 ? arguments[2] : undefined;
  var retries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var queryGet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  /* if (to.name === 'ContLogin') {
    return next()
  }*/
  ////console.log('calcular menu')
  window.userInfo = tasks.getUserInfo();
  var userInfo = window.userInfo;
  var userLogin = userInfo && userInfo.userLogin;
  // save returnUrl fron multiple objects
  queryGet = utils.dictIsNotNull(queryGet) || utils.dictIsNotNull(to.query) || utils.dictIsNotNull(from.query) || {};
  //console.log("to: ", to)
  //console.log("from: ", from)
  //console.log(router)
  // is login
  if (userLogin) {
    // has role info
    if (userInfo.userRoles) {
      // go to login
      if (to.name === 'ContLogin' && !to.query.returnUrl) {
        return next({
          path: envConfig.defaultPathRedirect
        });
      } else if (to.query && to.query.returnUrl) {
        // redirect to initial path
        var returnUrl = to.query.returnUrl;
        delete queryGet.returnUrl;
        return next({
          path: returnUrl,
          query: queryGet
        });
      } else {
        // continue with login
        var userRoles = userInfo.userRoles || [];
        var corporate = to.meta.corporate ? true : false;
        var isCorporate = userInfo.domain == 'intercorp.com.pe';
        var rolesRequired = to.meta && to.meta.authentified ? to.meta.authentified : [];
        // validate if user has roles
        if (rolesRequired.length) {
          var userRolesInPathRoles = utils.findArrayInArray(rolesRequired, userRoles);
          // validate if user roles match with required roles path
          if (rolesRequired.length && userRolesInPathRoles.length && (corporate && isCorporate || !corporate)) {
            // validate if exists returnUrl
            if (queryGet && queryGet.returnUrl) {
              var path = queryGet.returnUrl;
              delete queryGet.returnUrl;
              // redirect to returnRul
              next({
                path: path,
                query: queryGet
              });
            } else {
              // continue with login
              return next();
            }
          } else {
            // user not have permissions
            return next({
              name: '403'
            });
          }
        } else {
          if (corporate && isCorporate || !corporate) return next();else return next({
            name: '403'
          });
        }
      }
    } else {
      // await role info
      retries++;
      if (retries <= envConfig.MAX_RETRIES) {
        setTimeout(function () {
          return _routerBeforeEach(to, from, next, retries, queryGet);
        }, envConfig.DELAY_RETRIES * retries);
        return false;
      } else {
        //console.log('error getting authentication')
        return next({
          name: 'ContLogin'
        });
      }
    }
  } else {
    // go to login
    console.log('go to login:', to.name);
    if (to.name === 'ContLogin' || to.name === 'AuthPage') {
      return next();
    } else {
      var redirectPath = to.name === 'not-found' ? '/ContLogin' : to.path;
      queryGet.returnUrl = redirectPath;
      return next({
        name: 'ContLogin',
        query: queryGet
      });
    }
  }
};

// add function behavior to route component
router.beforeEach(_routerBeforeEach);

// export module for be declater in main.js
export default router;